import { createStoreHook } from '@/utils/createStoreHook';

import { ISessionScreenStoreContextValue, SessionScreenStore } from '@/store/SessionScreenStore';

export const useSessionScreenStore = createStoreHook<ISessionScreenStoreContextValue>(
  SessionScreenStore,
  'SessionScreenStore',
);
